var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 120 l0 -120 55 0 55 0 0 120 0 120 -55 0 -55 0 0 -120z m100 0 l0 -110 -45 0 -45 0 0 110 0 110 45 0 45 0 0 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 210 c0 -30 1 -30 55 -30 54 0 55 0 55 30 0 30 -1 30 -55 30 -54 0 -55 0 -55 -30z m100 0 c0 -17 -7 -20 -45 -20 -38 0 -45 3 -45 20 0 17 7 20 45 20 38 0 45 -3 45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 120 c0 -30 1 -30 55 -30 54 0 55 0 55 30 0 30 -1 30 -55 30 -54 0 -55 0 -55 -30z m100 0 c0 -17 -7 -20 -45 -20 -38 0 -45 3 -45 20 0 17 7 20 45 20 38 0 45 -3 45 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 30 c0 -30 1 -30 55 -30 54 0 55 0 55 30 0 30 -1 30 -55 30 -54 0 -55 0 -55 -30z m100 0 c0 -17 -7 -20 -45 -20 -38 0 -45 3 -45 20 0 17 7 20 45 20 38 0 45 -3 45 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/sections.54e59b333f52c4296bf293c40e0eb186.svg";
export { ForwardRef as ReactComponent };